import { useEffect, useState } from "react";
import { getMessaging, getToken } from "firebase/messaging";
import firebaseApp from "src/utils/firebase.utils";

const useFcmToken = () => {
  const [token, setToken] = useState<string | null>(null);
  const [notificationPermissionStatus, setNotificationPermissionStatus] =
    useState<string>("");

  useEffect(() => {
    const retrieveToken = async () => {
      try {
        if (
          "serviceWorker" in navigator &&
          typeof window !== "undefined" &&
          localStorage.getItem("pushToken") === null
        ) {
          // Ensure the service worker is ready
          const registration = await navigator.serviceWorker.ready;
          const messaging = getMessaging(firebaseApp);

          // Request notification permission
          const permission = await Notification.requestPermission();
          setNotificationPermissionStatus(permission);

          if (permission === "granted") {
            const currentToken = await getToken(messaging, {
              vapidKey:
                typeof window !== "undefined"
                  ? process.env.NEXT_PUBLIC_VAPID_KEY
                  : "",
              serviceWorkerRegistration: registration,
            });

            if (currentToken) {
              setToken(currentToken);
              localStorage.setItem("pushToken", currentToken);
              console.log("FCM Token retrieved:", currentToken);
            } else {
              console.warn("No registration token available.");
            }
          } else {
            console.warn("Notification permission denied.");
          }
        }
      } catch (error) {
        console.error(
          "An error occurred while retrieving the FCM token:",
          error
        );
      }
    };

    retrieveToken();
  }, []);

  return { fcmToken: token, notificationPermissionStatus };
};

export default useFcmToken;
